export default __webpack_public_path__ + "static/media/loadingspinner.99262a17.svg";